import React from 'react';

import { ExcludeDurationOption, ExcludeDurationOptionLabel } from '@recurrency/core-api-schema/dist/common/enums';

import { InfoTooltip } from 'components/Tooltip/InfoTooltip';

export function ExcludeMinMaxTooltip({ option, children }: { option: ExcludeDurationOption; children: JSX.Element }) {
  let durationText;
  switch (option) {
    case ExcludeDurationOption.Forever:
      durationText = 'forever';
      break;
    case ExcludeDurationOption.Custom:
      durationText = 'the specified duration';
      break;
    default:
      durationText = ExcludeDurationOptionLabel[option];
  }

  return (
    <InfoTooltip
      title={`Updating a custom min/max will also exclude that item from recommendations for ${durationText} based on your settings.`}
    >
      {children}
    </InfoTooltip>
  );
}
